import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioEvents, ProStudioContext } from '../prostudio.xstate.types';
import { loadBotPypes } from './load-bot-pypes';
import { Pype } from '../prostudio.api-service.types';
import { ChannelMutationProps, mutateChannel } from '../../utils';

export const updateChannel = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  botPypes: Pype[];
  channelId: string;
  channelName: string;
  pypeId: string;
  pypeName: string;
} | void> => {
  if (event.type !== 'updateChannel') {
    return;
  }

  const projectId = ctx.project?.id;
  const uniqueCustomerId = ctx.project?.projectProStudioSetting?.customerId;
  const botId =
    ctx.customerId && ctx.botName
      ? `${ctx.customerId}.${ctx.botName}`
      : undefined;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  if (!uniqueCustomerId) {
    throwErrorWithId('Customer ID is required');
    return;
  }

  if (!botId) {
    throwErrorWithId('Bot ID is required');
    return;
  }

  const { cb, ...channelProps } = event.payload;

  const channel: ChannelMutationProps = channelProps;

  await mutateChannel({
    channel,
    projectId,
    requestAction: 'update',
    cb,
    uniqueCustomerId,
    botId,
  });

  const { botPypes } = await loadBotPypes(ctx, event);

  return {
    botPypes,
    channelId: event.payload.id,
    channelName: event.payload.name || '',
    pypeId: event.payload.pypeId,
    pypeName: botPypes[0]?.name || '',
  };
};
